import { Collapse } from 'bootstrap'
import React, { Component } from 'react'
import { Card, CardDeck, Col, Container, Table } from 'react-bootstrap'
import bmo from '../photo/bmo.jpg'

export default class Bmo extends Component {
    render() {
        return ( 
            <Container >
                <h1  className="h1 ">Бондаренко Максим Олексійович</h1>
                <hr />
                <div className="about-teach ">
                    <Col sm={7}>
                        
                        <p className="p"><b>Бондаренко Максим Олексійович</b>  - 
                        доктор технічних наук, професор, завідуючий кафедрою приладобудування, мехатроніки та комп’ютеризованих
                        технологій з вересня 2020 року Черкаського державного технологічного університету.</p>
                        <h3 className="text-center"><b>Біографія</b> </h3><hr />
                        
                        
                        <p className="p">У 2000 році закінчив Черкаський державний технологічний 
                        університет, отримав кваліфікацію "інженер-механік"</p>

                        <p className="p">У 2006 році захистив кандидатську дисертацію з технічних наук
                        за спеціальністю 05.03.07 "Процеси фізико-технічної обробки" 
                        (назва дисертаційного дослідження: "Підвищення ефективності електронної 
                        технології та обладнання для фінішної обробки оптичних пластин 
                        під вироби мікрооптики", науковий керівник: д-р техн.наук, 
                        професор Ващенко В.А.) в Національному технічному 
                        університеті України "Київський політехнічний інститут"</p>
                        <p className="p"> У 2008 році отримав вчене звання доцента кафедри фізики 
                        Черкаського державного технологічного університету</p>
                        <p className="p">Викладає дисциплини: </p>
                        <ul>
                            <li >«Біомеханіка», </li>
                            <li >«Біомеханіка, мікро- та наноінженерія»</li>
                            <li >«Метрологічне забезпечення теплотехнічних вимірювань»,</li>
                            <li >«Проектування пристроїв мікросистемної техніки»,</li>
                            <li >«Менеджмент»</li>
                            <li >«Основи біоніки»</li>
                            <li >«Акредитація вимірювальних та випробувальних лабораторій»</li>
                            <li >«Основи робототехніки»</li>
                        </ul>
                        
                        <p className="p"> Робота за сумісним професором та зав. кафедрой менеджмента 
                        Східно-європейського університету економіки та менеджменту (м. Черкаси).</p>

                        <h3 className="text-center"><b> Наукова діяльність</b></h3><hr />
                    
                        <p className="p"></p>
                        <p className="p">Інтереси: отримання мікроелементів та функціональних шарів на 
                        діелектричних матеріалах електронними технологіями; інженерні нанотехнології; 
                        розрахунок та проектування компонентів мікросистемної техніки; атомно-силова мікроскопія.</p>  
                          
                          <hr />  
                    
                    </Col>
                    <Col sm={5}>
                        
                        <CardDeck border="dark" className='m-3'>
                            <Card className="card">
                                <img
                                    
                                    src={bmo}
                                />
                                <Card.Body>
                                    <Card.Title  className="table-title"> <span ><b> БОНДАРЕНКО <br />Максим Олексійович</b></span> </Card.Title> <hr />
                                    <Table >
                                        
                                        <tr>
                                            <td className="table-col-1" > Місце роботи </td> 
                                            <td className="table-col-2"> Черкаський державний технологічний університет </td>

                                        </tr>
                                        <tr>
                                            <td className="table-col-1 " > Освіта </td> 
                                            <td className="table-col-2" > 
                                                <ul>
                                                    <li>Черкаський державний технологічний університет</li>
                                                </ul>
                                                
                                            </td>

                                        </tr>
                                        <tr>
                                            <td className="table-col-1 " > Науковий ступінь</td> 
                                            <td className="table-col-2 "> доктор технічних наук </td>

                                        </tr>
                                        <tr>
                                            <td className="table-col-1 " > Наукове звання</td> 
                                            <td className="table-col-2 "> Доцент</td>

                                        </tr>
                                    </Table>
                                    
                                    
                                </Card.Body>
                            </Card>
                        </CardDeck>
                        
                    </Col>
                    
                       
                </div>
            </Container>
        )
    }
}